import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    showMark?: boolean
}

/** Flag-on-contour mark and the MORROW wordmark. Inherits the current text colour. */
export const Logo: FC<LogoProps> = ({ className, showMark = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            {showMark && (
                <svg viewBox='0 0 32 32' aria-hidden='true' className='size-7 shrink-0'>
                    <circle cx='16' cy='16' r='15' fill='none' stroke='currentColor' strokeOpacity='0.35' />
                    <path d='M5.5 22.5c3.2-3.4 6.7-5 10.5-5s7.3 1.6 10.5 5' fill='none' stroke='currentColor' strokeOpacity='0.45' strokeLinecap='round' />
                    <path d='M15 7.5v12' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
                    <path d='M15.8 7.8l6.4 2.6-6.4 2.6z' fill='currentColor' />
                </svg>
            )}

            <span className='type-wide text-[15px] font-semibold uppercase leading-none tracking-[0.16em]'>
                Morrow
            </span>
        </span>
    )
}
